module.exports = __webpack_public_path__ + "static/media/UK.522cd947.png";